export default __webpack_public_path__ + "static/media/sendIcon.0ca86cc6.svg";